import { useLocation, useNavigate, useParams } from "@tanstack/react-router";

import { logger, PortalEvents } from "~/lib/logger";

import { Tabs, TabsList, TabsTrigger } from "../ui/tabs";

const locationDetailsTabsMap = {
  profile: "Profile",
  devices: "POS Devices",
  "kds-devices": "KDS Devices",
  stations: "Stations",
  tips: "Tips",
  receipts: "Receipts",
  "end-of-day": "End of Day",
  discounts: "Discounts",
  "voids-and-refunds": "Voids & Refunds",
  "online-ordering": "Online Ordering",
} as const;

type LocationDetailTab = keyof typeof locationDetailsTabsMap;
const locationDetailTabs: LocationDetailTab[] = [
  "profile",
  "devices",
  "kds-devices",
  "stations",
  "tips",
  "receipts",
  "end-of-day",
  "discounts",
  "voids-and-refunds",
  "online-ordering",
];

export default function LocationTabs() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams({ from: "/_authenticated/locations/$id" });

  // Extract current tab from pathname
  const pathParts = location.pathname.split("/");
  const currentTab = pathParts[3] ?? "profile"; // Default to profile

  return (
    <Tabs
      className="mt-4"
      onValueChange={(value) => {
        logger.info(PortalEvents.TAB_NAVIGATION, {
          tab_name: value,
          previous_tab: currentTab,
          location_id: params.id,
          context: "location_details",
        });
        void navigate({ to: `/locations/${params.id}/${value}` });
      }}
      value={currentTab}
    >
      <div className="overflow-x-auto">
        <TabsList className="gap-1">
          {locationDetailTabs.map((tab) => (
            <TabsTrigger key={tab} value={tab}>
              {locationDetailsTabsMap[tab]}
            </TabsTrigger>
          ))}
        </TabsList>
      </div>
    </Tabs>
  );
}
